<div *ngIf="ticket_flag">    
    <div class="modal-header">
      <h4 class="modal-title">{{'TRANSFERSPARE.TICKETDETAILS'|translate}}</h4>
      <img src="assets/media/icons/png/check.png" (click)="later()">
    </div>
    <!-- body begin -->
    <div class="modal-body">
      <form class="form-horizontal" role="form">
        <div class="row">
          <div class="col-lg-6">
            <div class="row mt-2">
              <label class="col-lg-5 control-label ">{{'NEWTCKT.TCKID'| translate}} </label>
              <div class="col-lg-6 word"> {{ticket_details?.ticket_id}}</div>
            </div>
            <div class="row mt-2">
              <label class="col-lg-5 control-label ">{{'NEWTCKT.WRKTYP'| translate}} </label>
              <div class="col-lg-6 word"> {{ticket_details?.work_type}}</div>
            </div>
            <div class="row  mt-2">
              <label class="col-lg-5 control-label ">Job Logged By</label>
              <div class="col-lg-6 word" *ngIf="raise_name != 'Customer'"> {{raise_name}} - {{ticket_details?.raised_by}} </div>
              <div class="col-lg-6 word" *ngIf="raise_name == 'Customer'"> {{raise_name}} - {{ticket_details?.job_logged_by}} </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row  mt-2">
              <label class="col-lg-5 control-label ">Facility Name</label>
              <div class="col-lg-6 word"> {{ticket_details?.customer_name}}</div>
            </div>
            <div class="row  mt-2">
              <label class="col-lg-5 control-label ">{{'NEWTCKT.PRI'| translate}} </label>
              <div class="col-lg-6 word"> {{ticket_details?.priority}}</div>
            </div>
            <div class="row mt-2">
              <label class="col-lg-5 control-label ">{{'NEWTCKT.PROB'| translate}} </label>
              <div class="col-lg-6 word"> {{ticket_details?.problem}}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h5 class="mt-3">Equipment Details</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="row  mt-2">
              <label class="col-lg-5 control-label ">{{'NEWTCKT.PRODUCT'| translate}} </label>
              <div class="col-lg-6 word">{{ticket_details?.product_category}}</div>
            </div>
            <div class="row  mt-2">
              <label class="col-lg-5 control-label ">{{'SPARE.MODEL'| translate}} </label>
              <div class="col-lg-6 word"> {{ticket_details?.model}}</div>
            </div>
            <div class="row  mt-2">
              <label class="col-lg-5 control-label ">{{'NEWTCKT.SERIAL'| translate}} </label>
              <div class="col-lg-6 word"> {{ticket_details?.serial_no}}</div>
            </div>
            <div class="row  mt-2">
              <label class="col-lg-5 control-label ">Start date </label>
              <div data-title="Expiry Date"
                [ngClass]="{'date_color1 word col-lg-6': falg === true,'date_color2 word col-lg-6':falg === false}">
                {{ticket_details?.start_date}}
              </div>
            </div>
            <!-- <div class="row  mt-2">
              <label class="col-lg-5 control-label ">{{'NEWTCKT.SUP_SC'| translate}} </label>
              <div class="col-lg-6 word"> {{ticket_details?.support_scope}}</div>
            </div> -->
          </div>
          <div class="col-lg-6">
            <div class="row  mt-2">
              <label class="col-lg-5 control-label ">{{'NEWTCKT.SUBPRODUCT'| translate}} </label>
              <div class="col-lg-6 word"> {{ticket_details?.product_sub_category}}</div>
            </div>
            <div class="row  mt-2">
              <label class="col-lg-5 control-label ">{{'NEWTCKT.PART_NO'| translate}} </label>
              <div class="col-lg-6 word"> {{ticket_details?.part_number}}</div>
            </div>
            <div class="row  mt-2">
              <label class="col-lg-5 control-label ">{{'NEWTCKT.CON_CAT'| translate}} </label>
              <div class="col-lg-6 word"> {{ticket_details?.contract_type}}</div>
            </div>
            <div class="row  mt-2">
              <label class="col-lg-5 control-label ">{{'NEWTCKT.EX_DATE'| translate}} </label>
              <div data-title="Expiry Date"
                [ngClass]="{'date_color1 word col-lg-6': falg === true,'date_color2 word col-lg-6':falg === false}">
                {{ticket_details?.expiry_day}}
              </div>
            </div>
            
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h5 class="mt-3">{{'COMPLETEDTICKETS.COM_DET'| translate}}</h5>
          </div>
        </div>
        <div class="table-responsive GeneralTable text-nowrap">
          <table datatable="ng" [dtOptions]="dtOptions" class="table-bordered datatable w-auto mw-100">
            <thead>
              <tr>
                <th>{{'RAISETCKT.SE_NO' | translate}}</th>
                <th> {{'COMPLETEDTICKETS.JOB_ID' | translate}}</th>
                <th> {{'CUSTOMER.ST_DA' | translate}}</th>
                <th> Raised Date</th>
                <th>Completed Date</th>
                <th> Resolution Summary</th>
                <th> Resolution Image</th>
              </tr>
            </thead>
            <tbody *ngIf="ticket_details?.completed_tickets?.length != 0">
              <tr *ngFor="let items of ticket_details?.completed_tickets;let i=index">
                <td class="datatable-center">{{i+1}}</td>
                <td>{{items.ticket_id}} </td>
                <td>{{items.start_date}} </td>
                <td>{{items.raised_date}} </td>
                <td>{{items.completed_date}} </td>
                <td>{{items.resolution_summary}} </td>
                <td class="datatable-center" *ngIf='items.resolution_image == null'>
                </td>
                <td class="datatable-center" *ngIf='items.resolution_image != null'>
                  <a style="cursor: pointer;"  (click)="attachments(items,attachmentPage)">
                    <img src="assets/media/icons/png/attachment.png">
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">                   
          <div class="col-md-12">
            <h5 class="mt-3">Visit Details</h5>
          </div>
        </div>
        <div class="table-responsive GeneralTable text-nowrap">
          <table datatable="ng" [dtOptions]="dtOptions" class="table-bordered datatable w-auto mw-100">
            <thead>
              <tr>
                <th> Task NO</th>
                <th> MTP ID</th>
                <th>Engineer Name</th>
                <th>Raised Date</th>
                <th>{{'CUSTOMER.ST_DA' | translate}}</th>
                <th>Completed Date</th>
                <th>Status</th>
                <th> Resolution Summary</th>
                <th>Attachment / Service Report</th>
              </tr>
            </thead>
            <tbody *ngIf="ticket_details?.visit_details?.length != 0">
              <tr *ngFor="let item of ticket_details?.visit_details;let i=index">
                <td>{{item.visit_id}} </td>
                <td>{{ticket_id}} </td>
                <td>{{item.technician_name}} </td>
                <td>{{item.created_at|date:'dd-MM-yyyy'}} </td>
                <td>{{item.ticket_start_date|date:'dd-MM-yyyy'}} </td>
                <td>{{item.ticket_end_date|date:'dd-MM-yyyy'}} </td>
                <td>{{item.status_name}} </td>
                <td>{{item.resolution_summary}} </td>
                <td class="datatable-center">
                  <a style="cursor: pointer;" 
                      (click)="attachments(item,attachmentPage)">
                      <img src="assets/media/icons/png/attachment.png">
                  </a>
                  <button style="padding:0px;" class="btn btn-base center"
                  (click)="downloadPdf(ticket_id)">
                      <img src="assets/media/icons/png/eye.png" style="padding: 9px !important;">
                  </button> 
                </td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <div class="modal-footer">
          <button type="button" class="btn btn-outline disabledsubmit"
            (click)="later()">{{'NEW_SUBSCRIPTION.CLOSE' | translate}}</button>
        </div>
      </form>
    </div>
</div>
<ng-template #attachmentPage let-c="close" let-d="dismiss">
  <div class="modal-header">
      <!-- title for renew -->
      <h4 class="modal-title">{{ 'SITE.ATT'|translate }}</h4>
      <!-- icon for close -->
      <img src="assets/media/icons/png/check.png" (click)="d('Cross click')">
  </div>
  <div class="modal-body">
      <br>
      <div >
          <div>
              <div class="row">
                  <div class="col-sm-8 text-left" ><label class="control-label centeredlabel">Attachment1</label></div>
                  <div class="col-sm-2" style="margin-left: -8px;" *ngIf="attachment1_form.value.attachment1!='' && attachment1_form.value.attachment1!=null"><a style="cursor: pointer;"
                      (click)="downloadPdf2('Attachment1',attachment1_form.value.attachment1,imagetags)">
                      <img src="assets/media/icons/png/attachment.png">
                  </a></div>
                  <div class="col-sm-2 " *ngIf="attachment1_form.value.attachment1=='' || attachment1_form.value.attachment1==null"><span>-</span></div>
                  <div class="col-sm-2" *ngIf="attachment1_form.value.attachment1!='' && attachment1_form.value.attachment1!=null"><a style="cursor: pointer;"
                      (click)="download('Attachment1',attachment1_form.value.attachment1)">
                      <img src="assets/media/icons/common/Download.png" class="ml-2" >
                  </a></div>
                  <div class="col-sm-2 " *ngIf="attachment1_form.value.attachment1=='' || attachment1_form.value.attachment1==null">-</div>
              </div>
              <div class="row">
                  <div class="col-sm-8 text-left" ><label class="control-label centeredlabel">Attachment2</label></div>
                  <div class="col-sm-2" style="margin-left: -8px;" *ngIf="attachment1_form.value.attachment2!='' && attachment1_form.value.attachment2!=null"><a style="cursor: pointer;"
                      (click)="downloadPdf2('Attachment2',attachment1_form.value.attachment2,imagetags)">
                      <img src="assets/media/icons/png/attachment.png">
                  </a></div>
                  <div class="col-sm-2 " *ngIf="attachment1_form.value.attachment2=='' || attachment1_form.value.attachment2==null">-</div>
                  <div class="col-sm-2" *ngIf="attachment1_form.value.attachment2!='' && attachment1_form.value.attachment2!=null"><a style="cursor: pointer;"
                      (click)="download('Attachment2',attachment1_form.value.attachment2)">
                      <img src="assets/media/icons/common/Download.png" class="ml-2" >
                  </a></div>
                  <div class="col-sm-2 " *ngIf="attachment1_form.value.attachment2=='' || attachment1_form.value.attachment2==null">-</div>
              </div>
              <div class="row">
                  <div class="col-sm-8 text-left" ><label class="control-label centeredlabel">Attachment3</label></div>
                  <div class="col-sm-2" style="margin-left: -8px;" *ngIf="attachment1_form.value.attachment3!='' && attachment1_form.value.attachment3!=null"><a style="cursor: pointer;"
                      (click)="downloadPdf2('Attachment3',attachment1_form.value.attachment3,imagetags)">
                      <img src="assets/media/icons/png/attachment.png">
                  </a></div>
                  <div class="col-sm-2 " *ngIf="attachment1_form.value.attachment3=='' || attachment1_form.value.attachment3==null">-</div>
                  <div class="col-sm-2" *ngIf="attachment1_form.value.attachment3!='' && attachment1_form.value.attachment3!=null"><a style="cursor: pointer;"
                      (click)="download('Attachment3',attachment1_form.value.attachment3)">
                      <img src="assets/media/icons/common/Download.png" class="ml-2" >
                  </a></div>
                  <div class="col-sm-2 " *ngIf="attachment1_form.value.attachment3=='' || attachment1_form.value.attachment3==null">-</div>
              </div>
          </div>
      </div>
      <br>
  </div>
</ng-template>
<ng-template #imagetags let-c="close" let-d="dismiss">
	<div class="modal-header">
		<!-- title for renew -->
		<h4 class="modal-title">{{attachments_form}}</h4>
		<!-- icon for close -->
		<img src="assets/media/icons/png/check.png" class="modalClose" (click)="d('Cross click')">
	</div>
    <!-- <p>jasvfdjhagsfdjafsjdhftasd</p> -->
	<div class="modal-body">
		<img class="imagesize"  src={{httplink}}{{image_or_video}} />
	</div>
</ng-template>
